import auth from '@/router/auth'
import BlogIndex from '@/components/blogs/Index'
import BlogCreate from '@/components/blogs/Create'
import BlogUpdate from '@/components/blogs/Update'
import BlogShow from '@/components/blogs/Show'

export default [
  {
    path: '/blogs',
    name: 'blogs-index',
    component: BlogIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/blogs/create',
    name: 'blogs-create',
    component: BlogCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/blogs/update/:id',
    name: 'blogs-update',
    component: BlogUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/blogs/show/:id',
    name: 'blogs-show',
    component: BlogShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/blogs/router.js